<template>
    <div>
        <div class="row" style="display:none">
            <i>Colors Computer Kft., 6724, Szeged, Kossuth Lajos sgt. 60. Tel: 62/329927, 30/9569859, www.colors-computer.hu, colors@colors-computer.hu</i>
        </div>
        <div class="row mt-4">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h1 class="text-primary">Új szerviz munkalap</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <notification :show="showNotification" :errors="saveError"></notification>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <record-data :worksheet="worksheet" :users="users" :statusOptions="statusOptions"></record-data>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <client-data :worksheet="worksheet"></client-data>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <informations :worksheet="worksheet"></informations>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-3 col-xl-1">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="save" :disabled="isLoading">
                    <i v-if="isLoading" class="fa fa-spin fa-refresh"></i>
                    <i v-else class="fa fa-save"></i>
                    Mentés
                </button>
            </div>
            <div class="col-lg-3 col-xl-1">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="$router.back()"
                        :disabled="isLoading">
                    Vissza
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import RecordData from './worksheet/RecordData';
    import ClientData from './worksheet/ClientData';
    import Informations from './worksheet/Informations';
    import Notification from './worksheet/Notification';

    export default{
        name: 'NewWorksheet',
        data(){
            return {
                worksheet: {
                    recorder: null,
                    recordTime: new Date(),
                    recordStatus: '',
                    client: {
                        id: null,
                        name: '',
                        address: '',
                        phone: '',
                        email: ''
                    },
                    deviceType: '',
                    colorsNumber: '',
                    deviceUser: '',
                    devicePassword: '',
                    estimatedTime: '',
                    estimatedPrice: '',
                    priceOffer: false,
                    notification: false,
                    comment: '',
                    extraInfo: '',
                    extra: {
                        maintance: false,
                        firmware: false,
                        reinstall: false,
                        burnt: false,
                        switching: false,
                        notStarting: false,
                        update: false,
                        antivirusExpired: false,
                        internet: false,
                        performance: false,
                        cabel: false,
                        installBasic: false,
                        installMini: false,
                        antivirus: false,
                        testing: false,
                        durability: false,
                        datasave: false,
                        dust: false
                    }
                },
                showNotification: false,
                users: [],
                statusOptions: []
            }
        },
        computed: {
            saveError(){
                return this.$store.state.WorksheetModul.saveError;
            },
            isLoading(){
                return this.$store.state.WorksheetModul.loading;
            }
        },
        methods: {
            save(){
                this.showNotification = false;
                this.$store.dispatch('WorksheetModul/saveWorksheet', {
                    data: this.worksheet,
                    result: (res) => {
                        this.showNotification = true;
                        this.resetData();
                        window.scrollTo(0,0)
                    },
                    reject: (rej) => {
                        this.showNotification = true;
                        console.error(rej);
                        window.scrollTo(0,0)
                    }
                })
            },

            resetData(){
                this.worksheet = {
                    recorder: null,
                    recordTime: new Date(),
                    recordStatus: '',
                    client: {
                        id: null,
                        name: '',
                        address: '',
                        phone: '',
                        email: ''
                    },
                    deviceType: '',
                    colorsNumber: '',
                    deviceUser: '',
                    devicePassword: '',
                    estimatedTime: '',
                    estimatedPrice: '',
                    priceOffer: false,
                    notification: false,
                    comment: '',
                    extraInfo: '',
                    extra: {
                        maintance: false,
                        firmware: false,
                        reinstall: false,
                        burnt: false,
                        switching: false,
                        notStarting: false,
                        update: false,
                        antivirusExpired: false,
                        internet: false,
                        performance: false,
                        cabel: false,
                        installBasic: false,
                        installMini: false,
                        antivirus: false,
                        testing: false,
                        durability: false,
                        datasave: false,
                        dust: false
                    }
                }
            },
            loadUsers(){
                this.$store.dispatch('UserModul/getUserList', {
                    result: (res)=> {
                        this.users = [];
                        res.data.userList.forEach(user => {
                            this.users.push({
                                label: user.username,
                                value: user.id
                            });
                        });
                    }
                });
            },
            loadEventStatuses(){
                this.$store.dispatch('HelperModul/getEventStatuses', {
                    result: (res) => {
                        if(res !== 'NO_DATA'){
                            this.statusOptions = [];
                            res.eventStatusList.forEach(item => {
                                this.statusOptions.push(item.status);
                            });
                        }
                    },
                    reject: (rej) => {
                        console.error(rej);
                    }
                });
            },
        },
        mounted(){
            this.loadUsers();
            this.loadEventStatuses();
        },
        components: {
            RecordData,
            ClientData,
            Informations,
            Notification
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/NewWorksheet.vue